export default "__VITE_ASSET__tBFoy4VH__"